<h2
  mat-dialog-title
  [ngStyle]="{
    color: data.filterSettings.textColor,
    background: data.filterSettings.backgroundColor
  }"
>
  {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.TITLES.GEOGRAPHY' | translate }}
</h2>
<mat-dialog-content>
  <div class="selected-locations">
    <h2>
      {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.GEOGRAPHY.LOCATIONS_IN_FILTER' | translate }}
    </h2>
    @if (selectedCountries.length > 0) {
      <div class="selected-group">
        <h3>
          {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.GEOGRAPHY.COUNTRIES' | translate }}
        </h3>
        <div class="options">
          @for (data of selectedCountries; track data) {
            <div class="option">
              {{ data.name }}
              <span class="count">
                {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.LOCATION_COUNT' | translate: { count: data.locationCount } }}
              </span>
              <button mat-icon-button (click)="removeLocation(1, data.id)">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
    @if (selectedStateProvinces.length > 0) {
      <div class="selected-group">
        <h3>
          {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.GEOGRAPHY.REGION' | translate }}
        </h3>
        <div class="options">
          @for (data of selectedStateProvinces; track data) {
            <div class="option">
              {{ data.name }}
              <span class="count">
                {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.LOCATION_COUNT' | translate: { count: data.locationCount } }}
              </span>
              <button mat-icon-button (click)="removeLocation(2, data.id)">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
    @if (selectedCities.length > 0) {
      <div class="selected-group">
        <h3>
          {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.GEOGRAPHY.CITIES' | translate }}
        </h3>
        <div class="options">
          @for (data of selectedCities; track data) {
            <div class="option">
              {{ data.name }}
              <span class="count">
                {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.LOCATION_COUNT' | translate: { count: data.locationCount } }}
              </span>
              <button mat-icon-button (click)="removeLocation(3, data.id)">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="location-selector">
    <mat-form-field>
      <input
        matInput
        [placeholder]="'PERFORMANCE.MULTI_LOCATION.FILTERS.GEOGRAPHY.ADD_AREAS' | translate"
        cdkFocusInitial
        [matAutocomplete]="auto"
        [formControl]="locationControl"
      />
      <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="addLocationOpt($event)">
        @for (group of filteredLocations$ | async; track group) {
          <mat-optgroup [label]="group.name | translate">
            @for (option of group.options; track option) {
              <mat-option [value]="option">
                {{ option.name }}
                <span class="location-style">
                  {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.LOCATION_COUNT' | translate: { count: option.locationCount } }}
                </span>
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close(false)">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="close(true)">
    {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
